import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fullscreen bg-blue text-white text-center q-pa-md flex flex-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"30vh"} }, " 404 "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-h2",
    style: {"opacity":".4"}
  }, " Oops. Nothing here... ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}